let hasShownOfflineToast = false

export function getHasShownToast() {
  return hasShownOfflineToast
}

export function setHasShownToast(value) {
  hasShownOfflineToast = value
}
